import type { InferOutput } from "valibot";

// 'add_gift_card' form schema
export const addGiftCardSchema = v.object({
  product_id: v.number(),
  amount: v.pipe(v.number(), v.gtValue(14.99, "Le montant minimum est de 15.00 $")),
  delivery_date: v.date(),
  recipient_email: v.pipe(v.string(), v.email("Le courriel est invalide.")),
  recipient_name: v.string(),
  message: v.string(),
});
export type AddGiftCard = InferOutput<typeof addGiftCardSchema>;
